import { getUnitLabel, type PricingType } from "@/hooks/usePricingTypes";

interface PriceRow {
  pricing_type?: string | null;
  serves?: number | null;
}

/**
 * Human-facing unit suffix for a menu item's price on public pages — e.g.
 * "Dozen" or "Pans · serves 25". Returns `null` when there is no per-unit
 * meaning to show: no price row, or a flat section `price_override` (which
 * carries no `pricing_type`).
 *
 * The unit word comes from the admin-editable `pricing_types.unit_label` via
 * `getUnitLabel`, so it matches every other public page (packages, quotes) and
 * reflects label edits made in Settings.
 */
export function menuPriceUnit(
  pricingTypes: PricingType[] | undefined,
  priceRow: PriceRow | null,
): string | null {
  if (!priceRow || !priceRow.pricing_type) return null;
  const base = getUnitLabel(pricingTypes, priceRow.pricing_type);
  return priceRow.serves ? `${base} · serves ${priceRow.serves}` : base;
}
